<template>
  <el-tabs v-model="activeName">
    <el-tab-pane v-if="lcdAuth" :label="$l('elevatorLcd.elevatorLcd','智能屏幕')" name="first">
      <elevator-lcd-list></elevator-lcd-list>
    </el-tab-pane>
    <el-tab-pane v-if="lcdAuth" :label="$l('programCard.programCard','节目单')" name="second">
      <program-card-list></program-card-list>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import ElevatorLcdList from "@/views/smartScreen/ElevatorLcdList";
  import ProgramCardList from "@/views/smartScreen/PogramCardList";

  export default {
    components: {ElevatorLcdList, ProgramCardList},
    data() {
      return {
        lcdAuth: this.$auth(73),
        // userThirdAuth: this.$auth(71),
        activeName: "first",
      };
    },
    mounted() {
      if (this.lcdAuth) {
        this.activeName = "first";
        return;
      }
      if (this.userThirdAuth) {
        this.activeName = "third";
        return;
      }
    },
    methods: {},
  };
</script>
<style lang="scss" scoped>
</style>
